import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

export const Options = new Mongo.Collection('flight_options');

Options.allow({
    insert() { return true; },
    update() { return true; },
    remove() { return true; },
});

export const Option = new SimpleSchema({
    title: {
        type: String,
        label: "titre"
    },
    price: {
    	type: Number,
    	label: "prix"
    },
    reference: {
        type: String,
        label: "Référence sur le site internet",
        optional: true
    },
    createdAt: {
        type: Date,
        label: "Date de création",
        autoValue: function() {
            return new Date();
        }
    }
  });

Options.attachSchema(Option);

// Dbs methods : 

Meteor.methods({
  'options.remove'(optionId) {
    Options.remove(optionId);
  },
  'options.update'({_id, attributes}) {
    Options.update(_id, { "$set": attributes }); 
  },
  'options.insert'({attributes}) {
    Options.insert(attributes); 
  }
});

Options.helpers({
  displayValue() {
    return this.title + ' - ' + this.price + '€';
  }
});



/** WEBPACK FOOTER **
 ** ./src/universal/collections/flights-type/options.js
 **/